var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"ps-4 pt-0",attrs:{"label":"ordina per","items":_vm.sortOptions,"value":_vm.sortFilter,"hide-details":""},on:{"change":_vm.handleSortFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }